import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IDelayReason } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getDelayReasonList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDelayReason[]>('/delayReason/list', data)
    .then((response) => response.data);
};

export const getDelayReasonAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/delayReason/availableColumns')
    .then((response) => response.data);
};

export const getDelayReasonAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/delayReason/availableGroupColumns')
    .then((response) => response.data);
};

export const createDelayReason = (delayReason: IDelayReason) => {
  return instance()
    .post('/delayReason/create', delayReason)
    .then((response) => response.data);
};

export const updateDelayReason = (delayReason: IDelayReason) => {
  return instance()
    .post('/delayReason/update', delayReason)
    .then((response) => response.data);
};

export const deleteDelayReason = (delayReasonId: number) => {
  return instance()
    .post('/delayReason/archive', { delayReasonId })
    .then((response) => response.data);
};

export const recoverDelayReason = (delayReasonId: number) => {
  return instance()
    .post('/delayReason/recover', { delayReasonId })
    .then((response) => response.data);
};

export const loadDelayReason = (delayReasonId: number) => {
  return instance()
    .post<IDelayReason>('/delayReason/load', { delayReasonId })
    .then((response) => response.data);
};
